<template>
  <div class="ly1" style="position: relative" v-if="contentShow">
    <!-- <div class="noDateShow" v-if="noDateShow">暂无数据</div> -->
    <div class="infoL ET">
      <LeftList :keyMap="keyMap" :data="leftData" />
    </div>
    <div class="ly1-right infoR" style="margin-top: 10px">
      <el-radio-group
        v-if="joinType"
        class="radioGroup"
        v-model="period"
        size="medium"
        @change="periodChangePav"
      >
        <el-radio-button label="0">按日</el-radio-button>
        <el-radio-button label="1">按周</el-radio-button>
        <el-radio-button label="2">按月</el-radio-button>
      </el-radio-group>
      <ChartLine
        @childLine="getTpview"
        :chartOption="chartOption"
        height="420px"
        width="1300px"
        typeShow="123123"
      />
    </div>
  </div>
</template>

<script>
import { pavingQualityEfficiency } from "../../../../utils/api";
import LeftList from "../../../../components/layout/leftListT";
// import Rolling from "../../../../components/chart/rolling";
// import Compaction from "../../../../components/chart/compaction";
import ChartLine from "../../../../components/chart/line6";
// import GridLayout from "../../../../components/layout/grid";
export default {
  data() {
    return {
      leftData: [],
      chartOption: {},
      joinType: true,
      period: "0",
      keyMap: {
        maxWorkTime: ["最大作业时长", "h"],
        minWorkTime: ["最小作业时长", "h"],
        avgWorkTime: ["平均作业时长", "h"],
        maxWorkMileage: ["最大作业里程", "km"],
        minWorkMileage: ["最小作业里程", "km"],
        avgWorkMileage: ["平均作业里程", "km"],
      },
      contentShow: false,
      noDateShow: false,
      setData: ''
    };
  },
  computed: {
    // workId() {
    //   return this.$store.getters["quality/activeWorkId"];
    // },
  },
  created() {},
  mounted() {
    // this.getData();
  },
  props: {
    pavingEfficiencyData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    activeIndex2Code: {
      type: Number,
      default: function () {
        return 9;
      },
    },
    workId: {
      type: Number,
      default: function () {
        return 0;
      },
    },
  },
  watch: {
    pavingEfficiencyData: function (newValue) {
      console.log(newValue);
      if (newValue.data.length == 0 || newValue.data == null) {
        // this.noDateShow = true;
        this.setData = newValue;
        this.getData(this.setData);
      } else {
        // this.noDateShow = false;
        this.setData = newValue;
        this.getData(this.setData);
        // this.dataValue = newValue;
      }
    },
    activeIndex2Code: {
      handler(newVal) {
        console.log(newVal);
        // setTimeout(function(){
        if (newVal == 2) {
          this.contentShow = true;
        } else {
          this.contentShow = false;
        }
        // },100)
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    periodChangePav(e) {
      console.log(e);
      //   this.setShow = e
      let params = {
        workId: this.workId,
        mode: e,
      };
      this.$emit('childFn', e)
      pavingQualityEfficiency(params).then((res) => {
        console.log(res);
        this.getData(res.data.content.info);
      });
    },
    getTpview(e) {
      this.$store.commit("setTp_view", e);
    },
    getData(res) {
      //console.log(res)
      //   let getDataVal = res.data
      this.leftData = res;
      let resGet = res.data;
      const xAxisList = [];
      const yData_1 = [];
      const yData_2 = [];
      for (let key in resGet) {
        xAxisList.push(resGet[key].name);
        yData_1.push(resGet[key].values[0]);
        yData_2.push(resGet[key].values[1]);
      }
      //   let getxAxisList = xAxisList.sort()
      //   console.log(getxAxisList)

      let series = [
        {
          name: "作业时长",
          type: "bar",
          data: yData_1,
        },
        {
          name: "作业里程",
          type: "bar",
          yAxisIndex: 1,
          data: yData_2,
        },
      ];
      //   for(let i=0;i<getDataVal.length;i++){
      //     let yData = []
      //     for(let j=0;j<getxAxisList.length;j++){
      //       yData.push(getDataVal[i].pileTemperatureMap[getxAxisList[j]])
      //     }
      //     let setObj = {
      //       name: getDataVal[i].paverEquipName,
      //       type: 'line',
      //       data: yData
      //     }
      //     series.push(setObj)
      //   }
      //console.log(series)
      this.chartOption = Object.assign(
        {},
        {
          dataZoomEnd: Math.min(100, Math.ceil((8 / xAxisList.length) * 100)),
          legend: {
            // data: legend,
          },
          grid: {
            bottom: 70,
            top: 30,
            left: 30,
            right: 70
          },
          xAxis: [
            {
              type: "category",
              data: xAxisList,
              splitArea: {
                show: true,
              },
              splitLine: {
                show: false,
              },
              axisLabel: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisLine: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "H",
              splitArea: {
                show: true,
              },
              splitLine: {
                show: false,
              },
              axisLabel: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisLine: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
            {
              type: "value",
              name: "km",
              splitArea: {
                show: true,
              },
              splitLine: {
                show: false,
              },
              axisLabel: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisLine: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: 0,
              end: 100,
              handleSize: "10%",
              height: 10,
              handleStyle: {
                borderWidth: 2,
              },
              bottom: "5%",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          series: series,
        }
      );
    },
  },
  components: {
    LeftList,
    // Rolling,
    // Compaction,
    ChartLine,
    // GridLayout,
  },
};
</script>

<style lang="scss" scoped="">
.noDateShow {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba($color: #ffffff, $alpha: 0.7);
  z-index: 100;
  text-align: center;
  line-height: 640px;
}
.infoL {
  width: 456px;
  height: auto;
  float: left;
}
.infoR {
  width: 1344px;
  height: 280px;
  float: left;
  margin-left: 24px;
  position: relative;
  .typeChart {
    width: 100%;
    height: 224px;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}
</style>